<ng-container *ngIf="!!get">
    <tt-card>
        <tt-checkbox ttLabel="from_same_order" [(ttModel)]="get.from_same_order" (ttModelChange)="readGrid()"></tt-checkbox>
    </tt-card>
    <tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
</ng-container>
<!-- {{ get | json }} -->
